import React from "react";
import V20Embed from "@/components/mock/V20Embed";
export default function Rules() {
  return <V20Embed view="rules" testid="rules-view" />;
}
